/**
 * HTTP layer for the product catalog. Product CRUD, product-picture upload, and
 * grid stats.
 *
 * Contains:
 * - fetchProducts / fetchProduct: reads
 * - postProduct / patchProduct / deleteProduct: writes
 * - patchProductPicture: product image upload
 * - fetchProductsStats: product grid stats
 */
import apiClient from '@sophocles/http-common';

const PRODUCT_ENDPOINT = '/warehouse/products';

export const fetchProducts = queryParams =>
  apiClient.get(`${PRODUCT_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchProduct = productId => apiClient.get(`${PRODUCT_ENDPOINT}/${productId}/`).then(res => res.data);

export const postProduct = data => apiClient.post(`${PRODUCT_ENDPOINT}/`, data).then(res => res.data);

export const patchProduct = (productId, data) =>
  apiClient.patch(`${PRODUCT_ENDPOINT}/${productId}/`, data).then(res => res.data);

// Picture lives on the Product as an ImageField, so it can't ride the
// JSON patch — send it as multipart. Axios sets the multipart boundary
// automatically when handed a FormData body.
export const patchProductPicture = (productId, file) => {
  const formData = new FormData();
  formData.append('picture', file);
  return apiClient.patch(`${PRODUCT_ENDPOINT}/${productId}/`, formData).then(res => res.data);
};

export const deleteProduct = productId => apiClient.delete(`${PRODUCT_ENDPOINT}/${productId}/`);

// odl-app summary stats for the products grid — distinct base path from the
// legacy warehouse endpoint above.
export const fetchProductsStats = params => apiClient.get('odl-app/products/stats/', { params }).then(res => res.data);
